import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { authActionlogout, dataTaggerActionClearAll, memoActionDelAll, sequenceActionReset } from '@laramie/ui';
import timeout from '../../assets/images/timeout.png';
import { ssoEnabled, ssoLogout } from '../../utils/sso';


function UnauthorizedView() {

    const mount = () => {

        setTimeout(() => {
            dispatch( memoActionDelAll() );
            dispatch( dataTaggerActionClearAll() );
            dispatch( sequenceActionReset() );
            dispatch( authActionlogout() );
            // Con la sesión de Keycloak abierta, /login volvería a entrar solo y a
            // caer acá de nuevo: se cierra también la de Keycloak.
            if (ssoEnabled()) ssoLogout();
        }, 4000);

        const unmount = () => {}
        return unmount;
    }
    useEffect(mount, []);

    const dispatch = useDispatch();


    return (
        <section className='m-top-50 text-center'>

            <h2>La sesión ha expirado</h2>
            <h3>Se redirigirá a la página de autenticación...</h3>

            <div className="m-top-100">
                <img src={timeout} alt="logo" width={250} height={250} />
            </div>

        </section>
    )
}

export default UnauthorizedView;
